import { render, staticRenderFns } from "./character-list.vue?vue&type=template&id=42b1d953&"
import script from "./character-list.vue?vue&type=script&lang=js&"
export * from "./character-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports